module.exports = __webpack_public_path__ + "media/assets/images/events/laura-interview-small-abd177b97aa4006da6f7bc428d41c4a8.png";